import {mapGetters} from "vuex";
import {DateTime} from "luxon";

export default {
    data() {
        return {}
    },
    computed: {
        ...mapGetters('app', ['firstName', 'lastName', 'address2', 'email', 'phone']),
        ...mapGetters('filter', ['journeyDate']),
        ...mapGetters('cart', {
            usedPromoCode: 'promoCode',
            cartBikes: 'bikes',
            cartEvents: 'events',
            cartTours: 'tours',
            cartAccessories: 'accessories',
            cartMerchandises: 'merchandises',
            cartAdditionalOptions: 'additionalOptions'
        }),
    },
    methods: {
        generateUUID() {
            // Helper function to generate a random hex digit
            const randomHexDigit = () => Math.floor(Math.random() * 16).toString(16);

            // Generate the UUID segments
            const segments = [
                randomHexDigit() + randomHexDigit() + randomHexDigit() + randomHexDigit(),
                randomHexDigit() + randomHexDigit() + randomHexDigit() + randomHexDigit(),
                '4' + randomHexDigit() + randomHexDigit() + randomHexDigit(),
                (8 + Math.floor(Math.random() * 4)).toString(16) + randomHexDigit() + randomHexDigit() + randomHexDigit(),
                randomHexDigit() + randomHexDigit() + randomHexDigit() + randomHexDigit() +
                randomHexDigit() + randomHexDigit() + randomHexDigit() + randomHexDigit() +
                randomHexDigit() + randomHexDigit() + randomHexDigit() + randomHexDigit()
            ];

            // Join the segments with hyphens to form the UUID
            return segments.join('-');
        },

        createPayload(paymentType, product) {
            // payment's main fields
            let payload = {
                debug: process.env.NODE_ENV === 'development',
                ref: this.referrer,
                discount_code: this.usedPromoCode ? this.usedPromoCode.code : null,
                firstName: this.firstName,
                lastName: this.lastName,
                email: this.email,
                phone: this.phone,
                address: this.address2.firstLine,
                postalCode: this.address2.zipCode,
                paymentType: paymentType,
                paymentToken: ''
            }

            // this part of JSON data object is common
            let data = {
                accessories: this.cartAccessories.map(i => ({
                    accessory_id: i.item.accessory_id,
                    price_id: i.priceOption.price_id,
                    qty: i.amount
                })),
                merchandises: this.cartMerchandises.map(i => ({
                    merchandise_id: i.item.id,
                    size: i.priceOption.size,
                    qty: i.amount
                })),
                additional_options: this.cartAdditionalOptions.map(i => ({
                    additional_option_id: i.item.id,
                    qty: i.amount
                }))
            }

            // structure for rentals checkout
            if (this.cartBikes.length && !product.isProduct) {
                payload = {
                    ...payload,
                    start: DateTime.fromISO(this.journeyDate).toFormat('yyyy-MM-dd') + " 00:00:00",
                    type: 'rental',
                    data: JSON.stringify({
                        ...data,
                        bikes: this.cartBikes.map(i => ({
                            type_id: i.item.type_id,
                            price_id: i.priceOption.price_id,
                            qty: i.amount,
                            insurance_qty: i.insuranceAmount
                        }))
                    })
                }
            }

            // structure for rentals checkout
            if (this.cartEvents.length && !product.isProduct) {
                payload = {
                    ...payload,
                    start: DateTime.fromISO(this.journeyDate).toFormat('yyyy-MM-dd') + " 00:00:00",
                    type: 'event',
                    data: JSON.stringify({
                        ...data,
                        event_id: this.cartEvents[0].item.event_id,
                        bikes: this.cartEvents.map(i => ({
                            type_id: i.item.type_id,
                            price_id: i.priceOption.price_id,
                            qty: i.amount,
                            insurance_qty: i.insuranceAmount
                        }))
                    })
                }
            }

            // structure for tour checkout
            if (this.cartTours.length && !product.isProduct) {
                payload = {
                    ...payload,
                    start: DateTime.fromISO(this.cartTours[0].slot.date).toFormat('yyyy-MM-dd') + ' ' + this.cartTours[0].slot.time,
                    type: 'tour',
                    data: JSON.stringify({
                        ...data,
                        tour_id: this.cartTours[0].item.id,
                        bikes: this.cartTours[0].item.bike_types.filter(j => (j.amount > 0)).map(j => ({
                            type_id: j.type_id,
                            price_id: null,
                            qty: j.amount,
                            insurance_qty: j.insuranceAmount
                        }))
                    })
                }
            }

            if (product.isProduct) {
                payload = {
                    debug: process.env.NODE_ENV === 'development',
                    ref: product.referrer,
                    firstName: this.firstName,
                    lastName: this.lastName,
                    email: this.email,
                    phone: this.phone,
                    discount_code: null,
                    type: 'product',
                    shipping_method: product.productShippingMethod,
                    data: JSON.stringify({
                        products: [
                            {
                                id: product.productVariantSelected,
                                qty: 1
                            }
                        ]
                    })
                }

                if (product.productShippingMethod === 'domestic_shipping') {
                    payload = {
                        ...payload,
                        shipping_address: product.productShippingAddress
                    }
                }
            }

            return payload;
        },
    }
}
